var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e3e0dc14556ac39c04ff225d7741b4db01a9b6a1"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["react-las-vegas@travpro-mobile"]={id:"e3e0dc14556ac39c04ff225d7741b4db01a9b6a1"};
      